module.exports = __webpack_public_path__ + "static/media/1 36 sove.fbf9dd12.mp3";